/**
 * Created by amir on 2/28/18.
 */

export default class WebSocket {
    static get $inject() {
        return ['CookiesService', '$rootScope'];
    }

    constructor(CookiesService, $rootScope) {
        this._CookiesService = CookiesService;
        this.$rootScope = $rootScope;
        this.eventList = ['tamper', 'bypass', 'armed', 'stay_armed', 'panic', 'supervised_radio_zone_alarm']
    }

    getToken() {
        return this._CookiesService.getCookie('token');
    }

    webSocketConnect(panelId) {
        this.authenticated = false;
        this.subscribed = false;
        this.forceClose = false;
        this._closeWebSocket();
        this.SockObj = new SockJS('https://websocket.crowcloud.xyz/sockjs/');
        this._setWebSocket(panelId);
    }

    _closeWebSocket() {
        if (this.SockObj) {
            this.forceClose = true;
            this.SockObj.close();
        }
    }

    eventHandler(eventObject) {

        if (eventObject.hasOwnProperty('data')) {
            let data = eventObject.data;

            if (data.hasOwnProperty('key')) {
                let eventName = data.key;

                if(this.eventList.includes(eventName)) {
                    this.$rootScope.$broadcast(eventName, eventObject.data);
                } else {
                    this.$rootScope.$broadcast('socketEvent', eventObject)
                }
            }
            else if (data.hasOwnProperty('groups')) {
                this.$rootScope.$broadcast('socketEvent', eventObject)
            }
        }
    }

    _setWebSocket(panelId) {
        this.SockObj.onopen = () => {
            this.authenticated = true;
            this.SockObj.send('{"type": "authentication", "value":"' + this.getToken() + '"}');
        };

        this.SockObj.onmessage = (eventObject) => {
            eventObject = JSON.parse(eventObject.data);
            this.eventHandler(eventObject);

            // console.log('text', eventObject);
            // console.log('zone', obj.zone);
            // console.log('area', obj.area);
            // console.log('pic', obj.pictures);
            // console.log('groups', obj.groups);
            // console.log('control_panel_info', obj.control_panel_info);

            if (this.authenticated && !this.subscribed) {
                this.SockObj.send('{"type": "subscribe", "value":' + panelId + '}');
                this.subscribed = true;
            }
        };

        this.SockObj.onclose = () => {
            if (!this.forceClose) {
                this.webSocketConnect();
            }
        }
    }
}



/** WEBPACK FOOTER **
 ** ./src/services/api/websocket.service.js
 **/